import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { EyeOffIcon, PencilIcon } from 'lucide-react';
import { ProductionView } from '../components/ProductionView';
import { NotFound } from './NotFound';
import { useAuth } from '../contexts/AuthContext';
import { useCatalog } from '../contexts/CatalogContext';
import { isLive, isUpcoming, STATUS_LABELS } from '../utils/production';
import { buttonClass } from '../utils/styles';
export function ProductionDetail() {
  const {
    slug = ''
  } = useParams();
  const [params] = useSearchParams();
  const {
    session
  } = useAuth();
  const {
    getBySlug,
    published
  } = useCatalog();
  const production = getBySlug(slug);
  if (!production) return <NotFound data-id="element-442" data-mp="clirzgle7p97" />;
  const publicVisible = isLive(production) || isUpcoming(production);
  if (!publicVisible && !session) return <NotFound data-id="element-443" data-mp="1a3iswwsufb3d" />;
  const related = published.filter(p => p.id !== production.id).slice(0, 12);
  const notice = session ? <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-md border border-graphite bg-coal px-4 py-3" data-id="element-444" data-mp="159ejm6w3uqz4">
      <p className="flex items-center gap-2 text-sm text-mist" data-id="element-445" data-mp="18apb1jrdin49">
        {!publicVisible && <EyeOffIcon aria-hidden="true" className="h-4 w-4" data-id="element-446" data-mp="uj10hkwrw6pe" />}
        Estado: <span className="font-medium text-white" data-id="element-447" data-mp="ugomfiu4yghm">{STATUS_LABELS[production.status]}</span>
        {!publicVisible && '· solo visible para administración'}
      </p>
      <Link to={`/admin/editar/${production.id}`} className={buttonClass('outline', 'sm')} data-id="element-448" data-mp="kjjut3hitstf">
        <PencilIcon className="h-3.5 w-3.5" data-id="element-449" data-mp="pkr4j838522q" />
        Editar
      </Link>
    </div> : undefined;
  return <ProductionView key={production.id} production={production} related={related} autoPlay={params.get('play') === '1'} notice={notice} data-id="element-450" data-mp="bl88hdnoth6s" />;
}